
            const data = {"name":"right","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m14.75 13.29-5.043 5.042-1.414-1.414 5.043-5.043-5.043-5.043 1.414-1.414 5.043 5.043a2 2 0 0 1 0 2.828Z\" _fill=\"#8E8EA9\"/>","originalColors":[{"type":"fill","color":"#8E8EA9"}],"stopColors":[]}}
        
                    module.exports = data
                    